export const FIRST_ATTEMPT_INDEX = "0-0";
//# sourceMappingURL=onTestBegin.js.map